import { render } from "./FollowUpNotesAdded.vue?vue&type=template&id=725cc97a&scoped=true&lang=pug"
import script from "./FollowUpNotesAdded.vue?vue&type=script&lang=js"
export * from "./FollowUpNotesAdded.vue?vue&type=script&lang=js"

import "./FollowUpNotesAdded.vue?vue&type=style&index=0&id=725cc97a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725cc97a"]])

export default __exports__